// Visit The Stimulus Handbook for more details 
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["tag"]
  static values = { tagId: Number }
  connect() {} 

  toggle() {
    // User has clicked the tag 
    this.refresh(document.querySelector("#matched_tag"))
    this.refresh(document.querySelector("#unmatched_tag"))
    this.refresh(document.querySelector("#mitigated_tag"))
  }  

  refresh(tag_field) {
    if (tag_field.value == this.tagIdValue)
      tag_field.value = ""
    else
      tag_field.value = this.tagIdValue

    tag_field.closest('form').dispatchEvent(new Event('input'))
  } 
}
